<template>
    <blocker-helper title='Generating Report'>
        <template v-slot:body>
            <div v-if="currentCase">
                <p class='processing-text'>Processing case</p>
                <p class='current-case'>{{currentCase}}</p>
            </div>
            <div class="progress">
                <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" :aria-valuenow="reportPercentage" aria-valuemin="0" aria-valuemax="100" :style="{width: `${reportPercentage}%`}">{{reportPercentage}}%</div>
            </div>
        </template>
    </blocker-helper>
</template>

<script>
import BlockerHelper from '../components/helpers/BlockerHelper.vue';
export default {
    name: 'ReportBlocker',
    components: {
        'blocker-helper': BlockerHelper,
    },
    props: ['currentCase', 'reportCasesCount'],
    data() {
        return {
            counter: 0,
        };
    },
    computed: {
        reportPercentage() {
            const percentage = Math.round(
                (this.counter / this.reportCasesCount) * 100
            );
            return isNaN(percentage) ? 0 : percentage <= 5 ? 5 : percentage;
        },
    },
    watch: {
        currentCase: function() {
            this.counter++;
        },
    },
};
</script>

<style scoped>
  .current-case {
      font-weight: bold;
  }
  .processing-text {
      margin-bottom: 0;
  }
</style>